import { Heading, Text } from "@instacover/ui"
import { createFileRoute } from "@tanstack/react-router"
import { Trans } from "react-i18next"

import { RunMutationOnRender } from "@/components/RunMutationOnRender"
import { ThankYouGraphic } from "@/components/thankYou/ThankYouGraphic"
import { useFinishSession } from "@/hooks/api/useFinishSession"
import { LogoHeader } from "@/sections/layouts/LogoHeader"

export const Route = createFileRoute("/$sessionId/_session/finished")({
  component: FinishedRoute,
})

function FinishedRoute() {
  const { sessionId } = Route.useParams()

  const { mutate: finishSession } = useFinishSession()

  return (
    <RunMutationOnRender
      mutationFn={async () => {
        finishSession({ sessionId })
      }}
    >
      <div>
        <LogoHeader className="mt-4 mb-[12dvh]" />
        <ThankYouGraphic className="custom-media-container mx-auto aspect-square w-full px-7" />

        <Heading as="h1" variant="h1" className="mt-8 mb-6 text-center uppercase" data-testid="finished-heading">
          <Trans i18nKey="finished.heading" />
        </Heading>

        <Text className="text-center">
          <Trans i18nKey="finished.description" />
        </Text>
      </div>
    </RunMutationOnRender>
  )
}
